"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqItems = [{
  question: "How long does it take to develop a photo?",
  answer: "We arrive with our photo cart or vintage bicycle and set up a scenic corner. We take portraits on analog black and white paper and develop the photographs directly on site. Guests can witness the magic of daylight development, living an interactive experience and taking home an immediate and tangible memory."
}, {
  question: "How long does it take to develop a photo?",
  answer: "The process is a perfect balance between craftsmanship and entertainment. Development takes place in a few minutes before the subjects' eyes. It is a 'slow' experience compared to digital, but fast enough to integrate perfectly into the rhythm of a reception or party."
}, {
  question: "Is it possible to customize the setup?",
  answer: "Certainly. Our vehicles, such as carts and three-wheeled bicycles, have a neutral and vintage aesthetic that adapts to many contexts. We can add floral or decorative details to harmonize with the theme of your wedding or event, always maintaining our authentic style."
}, {
  question: "Do you only operate in Perugia, or do you travel?",
  answer: "Our base is Perugia but we move throughout the national territory."
}, {
  question: "What happens if it rains or if the event is indoors?",
  answer: "Our equipment is versatile. Although our carts are ideal for squares and gardens, we can set up an elegant vintage corner inside the location. The important thing is to have a small dedicated space where we can operate and interact with guests."
}, {
  question: "Do you also provide digital files of the photos?",
  answer: "Our philosophy is linked to the uniqueness of the physical analog copy (unique positive copy)."
}];
export default function CuriositaEDettagli() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="curiosità-e-dettagli" className="dark bg-background text-foreground py-20 px-4 md:px-8 overflow-hidden">
      <div ref={ref} className={`max-w-4xl mx-auto transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-serif font-medium mb-4 tracking-tight text-foreground">
            Curiosities & Details
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-sans text-lg">Everything you need to know about the Vintage Portraits experience. From the development technique to the logistics of your event.</p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-2">
          {faqItems.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border/30 last:border-0 px-2">
              <AccordionTrigger className="hover:no-underline py-6 [&>svg:last-child]:hidden group">
                <div className="flex items-center justify-between w-full text-left pr-4">
                  <span className="font-mono text-base md:text-lg tracking-tight text-foreground/90 group-hover:text-primary transition-colors">
                    {item.question}
                  </span>
                  <Plus className="size-5 text-primary shrink-0 transition-transform duration-300 group-data-[state=open]:rotate-45" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="font-sans text-muted-foreground text-base leading-relaxed pb-6 pr-12">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-16 text-center">
          <p className="text-muted-foreground mb-6 font-mono text-sm">Do you have any other specific questions regarding your event?</p>
          <Button asChild variant="outline" className="border-primary/50 text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">
            <Link to="/ContactPage">Contact Us Now</Link>
          </Button>
        </div>
      </div>
    </section>;
}